import DOMPurify from 'dompurify';
import { useTranslation } from '../i18nNext';

export const useSanitizedTranslation = () => {
  const t = useTranslation();
  return (key: string, replacements: Array<string> | undefined = undefined) => {
    let translationValue = DOMPurify.sanitize(t(key));
    if (replacements) {
      replacements.forEach((replacement) => {
        translationValue = translationValue.replace('$var', replacement);
      });
    }
    return translationValue;
  };
};
